import Goal from "./components/Goals/Goals";
import Dashboard from "./Dashboard";
import Overview from "./components/Overview";
import ImportReport from "./components/Report/ImportReport";
import CDP from "./components/Report/CDP";
import DefaultContainer from "./components/DefaultContainer";
import GRI from "./components/Report/GRI";
import TSP from "./components/Report/TSP";
import ExportReport from "./components/Report/ExportReport";
import EsgReport from "./components/Report/EsgReport";
import SasbReport from "./components/Report/SasbReport";
import TeamManagement from "./components/TeamManagement";
import CreateGoal from "./components/Goals/CreateGoal";
import Homepage from "./Homepage";
import GoalsDetailPage from "./components/Goals/GoalsDetailPage";
import AssignGoal from "./components/Goals/AssignGoal";
import SupplierReports from "./components/Report/SupplierReports";
import InternalReports from "./components/Report/InternalReports";
import InternalDashboards from "./InternalDashboards";
import SupplierDashboards from "./SupplierDashboards";
import AuthRoute from "./AuthRoute";
import Register from "./Register";
import Editprofile from "./Editprofile";
import EsgDashboards from "./EsgDashboards";
import TspSupplierReportDetails from "./components/SupplierReports/Tsp/TspSupplierReportDetails";
import TspSupplierReport from "./components/SupplierReports/Tsp/TspSupplierReport";
import GriSupplierReport from "./components/SupplierReports/Gri/GriSupplierReport";
import GriSupplierReportDetails from "./components/SupplierReports/Gri/GriSupplierReportDetails";
import Facilities from "./components/Facilities/Facilities";
import FacilityDetails from "./components/Facilities/FacilityDetails";
import FacilityAnalyticDetail from "./components/Facilities/FacilityAnalyticDetail";
import AirQuality from "./components/Facilities/AirQuality";
import WaterManagement from "./components/Facilities/WaterManagement";
import HazardousManagement from "./components/Facilities/HazardousManagement";
import EnergyManagement from "./components/Facilities/EnergyManagement";
import DemoReport from "./components/Supplier/DemoReport";
import DemoReport1 from "./components/Supplier/DemoReport1";
import DemoReport2 from "./components/Supplier/DemoReport2";
import Reports from "./components/Reports/Reports";
import NewReportForm from "./components/Reports/NewReportForm";
import ReportsDataDetails from "./components/Reports/ReportsDataDetails";
import TspSupplierReportFinal from "./components/Report/TspSupplierReportFinal";
import TspSupplierReportFinalData from "./components/Report/TspSupplierReportFinalData";
import ReportsWaterDataDetails from "./components/Reports/ReportsWaterDataDetails";
import Suppliers from "./components/Report/Suppliers";
import SupplierDataGraph from "./components/Report/SupplierDataGraph";
import CDPQNA from "./components/Report/CDPQNA";
import Griqna from "./components/Report/Griqna";
import GriqnaDetails from "./components/Report/GriqnaDetails";
import SasbForm from "./components/Report/SasbForm";
import Sasb from "./components/Report/Sasb";
import CreateUser from "./components/UserManagement/CreateUser";
import CreateRole from "./components/UserManagement/CreateRole";
import AssignPermission from "./components/UserManagement/AssignPermission";
import ChangePassword from "./ChangePassword";
import Sbti from "./components/Report/Sbti";
import SupplierTspReport from "./components/SupplierReports/SuplierReport";
import UpdatePassword from "./UpdatePassword";

const Allroutes = [
    { path: "/dashboard", element: <Dashboard /> },
    { path: "/overview", element: <Overview /> },
    { path: "/importreport", element: <ImportReport /> },
    { path: "/exportreport", element: <ExportReport /> },
    { path: "/cdp", element: <CDP /> },
    { path: "/gri", element: <GRI /> },
    { path: "/tsp", element: <TSP /> },
    { path: "/esgreport", element: <EsgReport /> },
    { path: "/sasbreport", element: <SasbReport /> },
    { path: "/teammanagement", element: <TeamManagement /> },
    { path: "/goal", element: <Goal /> },
    { path: "/creategoal", element: <CreateGoal /> },
    { path: "/goaldetailpage", element: <GoalsDetailPage /> },
    { path: "/assigngoal", element: <AssignGoal /> },
    { path: "/internal-reports", element: <InternalReports /> },
    { path: "/supplier-reports", element: <SupplierReports /> },
    { path: "/internal-dashboards", element: <InternalDashboards /> },
    { path: "/supplier-dashboards", element: <SupplierDashboards /> },
    { path: "/supplier-data-graph", element: <SupplierDataGraph /> },
    { path: "/esg-dashboards", element: <EsgDashboards /> },
    { path: "/suppliers", element: <Suppliers /> },
    { path: "/editprofile", element: <Editprofile /> },
    { path: "/tspsupplierreport", element: <TspSupplierReport /> },
    { path: "/tspsupplierreportdetails", element: <TspSupplierReportDetails /> },
    { path: "/grisupplierreport", element: <GriSupplierReport /> },
    { path: "/grisupplierreportdetails", element: <GriSupplierReportDetails /> },
    { path: "/assets", element: <Facilities /> },
    { path: "/assetdetails", element: <FacilityDetails /> },
    { path: "/assetanalyticdetail", element: <FacilityAnalyticDetail /> },
    { path: "/airquality", element: <AirQuality /> },
    { path: "/watermanagement", element: <WaterManagement /> },
    { path: "/hazardousmanagement", element: <HazardousManagement /> },
    { path: "/energymanagement", element: <EnergyManagement /> },
    { path: "/reports", element: <Reports /> },
    { path: "/reportform", element: <NewReportForm /> },
    { path: "/reportsdatadetails", element: <ReportsDataDetails /> },
    { path: "/reportswaterdatadetails", element: <ReportsWaterDataDetails /> },
    { path: "/tspsupplierreportfinal", element: <TspSupplierReportFinal /> },
    { path: "/tspsupplierreportfinaldata", element: <TspSupplierReportFinalData /> },
    { path: "/cdpqna", element: <CDPQNA /> },
    { path: "/griqna", element: <Griqna /> },
    { path: "/griqnadetails", element: <GriqnaDetails /> },
    { path: "/sasbform", element: <SasbForm /> },
    { path: "/sasb", element: <Sasb /> },
    { path: "/sbti", element: <Sbti /> },
    { path: "/create-user", element: <CreateUser /> },
    { path: "/create-role", element: <CreateRole /> },
    { path: "/assign-permission", element: <AssignPermission /> },
    { path: "/changepassword", element: <ChangePassword /> },
    { path:"/supplier-tsp-report" ,element:<SupplierTspReport />} ,
    {path:"/updatepassword" ,element:<UpdatePassword/>},

];


export default Allroutes;